import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop
 * Globally scrolls window to top on route changes.
 * Mount once inside a component rendered within a Router.
 */
const ScrollToTop = ({ behavior = 'auto' }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior });
  }, [pathname, behavior]);

  return null;
};

export default ScrollToTop;
